<template>
    <v-card width="100%" flat>
        <v-card-title>
            <div class="headline">
                Uživatelé
            </div>
            <v-spacer></v-spacer>

            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Vyhledávání"
                    single-line
                    class="pt-0"
                    hide-details
            ></v-text-field>

            <v-spacer></v-spacer>

<!--            <v-btn fab dark small color="success" @click="addItem">-->
<!--                <v-icon dark>add</v-icon>-->
<!--            </v-btn>-->
        </v-card-title>

        <v-data-table
                v-model="selected"
                :headers="headers"
                :items="items"
                :search="search"
                class="elevation-2"
                dense
                hide-default-footer
                disable-pagination
        >
            <template v-slot:item.isActive="{ item }">
                <v-icon v-if="item.isActive" small color="green">check_circle</v-icon>
                <v-icon v-if="!item.isActive" small color="red">remove_circle</v-icon>
            </template>
            <template v-slot:item.isSuperuser="{ item }">
                <v-icon v-if="item.isSuperuser" small color="green">check_circle</v-icon>
                <v-icon v-if="!item.isSuperuser" small color="red">remove_circle</v-icon>
            </template>
            <template v-slot:item.profile.validUntil="{ item }">
                <span v-if="item.profile && item.profile.validUntil">
                    {{ item.profile.validUntil | moment("DD.MM.YY") }}
                </span>
            </template>
            <template v-slot:item.action="{ item }">
                <EditDeleteActions
                        @delete="deleteItem(item.id)"
                        @edit="editItem(item)"
                />
            </template>
        </v-data-table>

        <UserDialog ref="dialog" @complete="onComplete" />

        <DeleteConfirm :show="deleteConfirm"
                       @confirm="doDeleteConfirm"
                       @cancel="deleteConfirm=false"
        />
    </v-card>
</template>

<script>
    import UserDialog from '../components/dialogs/UserDialog'
    import BaseListMixin from '../mixins/BaseListMixin'

    export default {
        mixins: [BaseListMixin],
        components: {
            UserDialog
        },

        data () {
            return {
                module: 'user',
                headers: [
                    { text: 'Uživatelské jméno', value: 'username'},
                    { text: 'Jméno', value: 'firstName'},
                    { text: 'Příjmení', value: 'lastName'},
                    { text: 'E-mail', value: 'email'},
                    { text: 'Platnost', value: 'profile.validUntil', width: '90px'},
                    { text: 'Aktivní', value: 'isActive', width: '90px', align:'center'},
                    { text: 'Admin', value: 'isSuperuser', width: '90px', align:'center'},
                    { text: '', value: 'action', width:'1px', sortable: false},
                ],
            }
        }
    }
</script>

